import { SearchResult } from "./search-result";

export class AtsApplicationSource {
    Id: string;
    Name: string;
}

export class ApplicationSourceSearchResult extends SearchResult<AtsApplicationSource> {}
